<template>
  <div>
    <div class="row d-flex justify-content-center">
      <div class="col-md-10">
        <simple-wizard :finishButtonShow="btnFinishShow" :finishButtonText="btnFinishTxt" @finishstep="finishstep()" :onPrevButton="onPrevButton">
          <template slot="header">
            <h2>Build your profile</h2>
          </template>
          
          <div v-if="!isSuccessFetchStatusOnBoarding || isLoadingFetchUser" style="display: flex; justify-content: center; margin-top: 24px;">
            <i class="fas fa-spinner fa-spin" style="font-size: 40px;"></i>
          </div>
          <wizard-tab
            v-else
            v-for="step in steps"
            :key="step.key"
            :before-change="step.beforeChange"
          >
          <template slot="label">
            <i :class="step.icon"></i>
            <p>{{ step.label }}</p>
          </template>

          <component
            v-if="step.type === 'component'"
            :is="step.component"
            v-bind="step.props"
            :ref="step.ref"
            @on-validated="onStepValidated"
            @cc-info-saved="onCreditCardInfo"
          />

          <div v-if="step.type === 'onboarding'" class="centerform">
            <p style="text-align: center; font-weight: 600; font-size: 20px; margin-bottom: 16px;">
              Manage Your Credit Card
            </p>
            <RadioButtonManageYourCreditCard :onChangeValue="onChangeManageCreditCard" />
            <p v-show="minspend_setting.status" style="margin-top: 16px;">
              You are entering into a 12-month contract with a minimum spend requirement set forth in Addendum C of the Service and Billing Agreement
              <!-- You are entering into a 12 month contract with a minimum spend requirement of <strong>${{ MINIMUM_SPEND_FLAT }} each month</strong>. -->
              <!-- <strong>${{ minspend_setting.first_month }} after 30 days</strong>, 
              <strong>${{ minspend_setting.second_month }} after 60 days</strong> and
              <strong>${{ minspend_setting.monthly }} each month thereafter</strong>. -->
            </p>
            <ExistingCreditCard
              v-if="manageCreditCard == 'existing'"
              ref="stepExistingCard"
              :isMinimumSpend="minspend_setting.status"
            />
            <UpdateCreditCard
              v-if="manageCreditCard == 'update'"
              ref="stepUpdateCard"
              :isMinimumSpend="minspend_setting.status"
            />
          </div>

          <div v-if="step.type === 'info'">
            <el-collapse class="custom__accordion" v-model="activeName" style="margin-bottom: 16px;">
              <el-collapse-item title="BASIC INFORMATION" name="1" :class="{ 'error-class': isErrorBasicInformation }">
                <first-step ref="step2" @on-validated="onStepValidated" @on-change="onChangeBasicInformation" :ccInfo="ccInfo" />
              </el-collapse-item>
              <el-collapse-item title="BUSINESS INFORMATION" name="2" :class="{ 'error-class': isErrorBusinessInformation }">
                <second-step ref="step3" :basicInformation="basicInformation" @on-change="onChangeBusinessInformation" @on-validated="onStepValidated" :ccInfo="ccInfo" />
              </el-collapse-item>
            </el-collapse>
          </div>
          </wizard-tab>
        </simple-wizard>
      </div>
    </div>
  </div>
</template>
<script>
import FirstStep from './Includes/UserSetup/FirstStep.vue';
import SecondStep from './Includes/UserSetup/SecondStep.vue';
import ThirdStep from './Includes/UserSetup/ThirdStep.vue';
//import FourthStep from './Includes/UserSetup/FourthStep.vue';
import FinishStep from './Includes/UserSetup/FinishStep.vue';
import swal from 'sweetalert2';
import { SimpleWizard, WizardTab } from 'src/components';
import { RadioButton, RadioGroup, Collapse, CollapseItem } from 'element-ui';
import { 
  RadioButtonManageYourCreditCard,
  ExistingCreditCard,
  UpdateCreditCard
 } from '../../../../components/Pages/ProfileSetup';
import { MINIMUM_SPEND } from '../../../../shared/constants';

export default {
  data() {
    return {
      wizardModel: {},
      isAdmin:false,
      questionnaireCompleted:false,
      userdata: [],
      btnFinishShow:false,
      initialCheck:true,
      btnFinishTxt: 'Go To General Settings',
      manageCreditCard: 'existing',
      statusOnBoarding: false,
      isSuccessFetchStatusOnBoarding: false,
      emmplatform: false,
      minspend_setting:{
        status:false,
        first_month:0,
        second_month:0,
        monthly:0
      },
      activeName: ['1', '2'],
      basicInformation: {
        name: '',
        email: '',
        phoneNumber: '',
        phoneCallingCode: '',
        phoneCountryCode: '',
        country: '',
        state: '',
        address: '',
        city: '',
        zip: ''
      },
      businessInformation: {
        name: '',
        email: '',
        phoneNumber: '',
        phoneCallingCode: '',
        phoneCountryCode: '',
        country: '',
        state: '',
        address: '',
        city: '',
        zip: ''
      },
      isRenderAgreementClient: false,
      excludeOnBoarding: false,
      isErrorBasicInformation: false,
      isErrorBusinessInformation: false,
      isLoadingFetchUser: true,
      isValidStep2: false,
      registrationMethod: null,
      ccInfo: null,
    };
  },
  components: {
    FirstStep,
    SecondStep,
    ThirdStep,
    //FourthStep,
    FinishStep,
    SimpleWizard,
    WizardTab,
    RadioButtonManageYourCreditCard,
    ExistingCreditCard,
    UpdateCreditCard,
    [RadioGroup.name]: RadioGroup,
    [RadioButton.name]: RadioButton,
    [Collapse.name]: Collapse,
    [CollapseItem.name]: CollapseItem,
  },
  methods: {
    setClientFinishButtonText(response = {}) {
      const sidebar = response.clientsidebar || {};
      const hasDashboardAccess = !!(sidebar.local || sidebar.locator || sidebar.enhance || sidebar.b2b);
      this.btnFinishTxt = hasDashboardAccess ? 'Go To Dashboard' : 'Finish';
    },
    async validateStep(ref) {
      let validations = [];
      
      if(ref == 'step1'){
        this.isRenderAgreementClient = true;
      } else {
        this.isRenderAgreementClient = false;
      }

      const currentRef = this.$refs[ref];
      if (currentRef && typeof currentRef[0].validate === 'function') {
        const validationResult = Promise.resolve(currentRef[0].validate());

        if(ref === 'step2'){
          await validationResult.then((isValid) => {
            if(!isValid){
              this.isErrorBasicInformation = true;
              this.activeName = ['1'];
            } else {
              this.isValidStep2 = true;
            }
          });
        }

        validations.push(validationResult);
      }

      if (ref === 'step2') {
        const step3Ref = this.$refs.step3;
        if (step3Ref && typeof step3Ref[0].validate === 'function') {
          const validationResult = Promise.resolve(step3Ref[0].validate());

          validationResult.then((isValid) => {
            if(!isValid && this.isValidStep2){
              this.isErrorBusinessInformation = true;
              this.activeName = ['2'];
            }
          });

          validations.push(validationResult);
        }

        this.isRenderAgreementClient = true;
      }

      this.btnFinishShow = true;
      
      return Promise.all(validations).then((results) => {
        // For agency setup complete
        const allValid = results.length > 1 && results.every(result => result === true);
        if(allValid && this.userdata.user_type != 'client'){
          this.makeFinishSetup();
          return true;
        }
        // For agency setup complete

        // For client fill cc default
        if(allValid && this.userdata.user_type == 'client' && (this.userdata.customer_payment_id || this.userdata.manual_bill == 'T')){
          // console.log('masuk sini');
          this.makeFinishSetup();
          return true;
        }
        // For client fill cc default\

        return results.every(function(result) {
          return result === true;
        });
      });
    },
    checkInformationError(data) {
      const requiredFields = [
        'name',
        'email',
        'phoneNumber',
        'country',
        'state',
        'address',
        'city',
        'zip'
      ];

      for (const key of requiredFields) {
        if (!data[key] || data[key].toString().trim() === '') {
          return true;
        }
      }
      return false;
    },
    onStepValidated(validated, model) {
      //console.log(validated.FullName);
      this.wizardModel = { ...this.wizardModel, ...model };
      //console.log(this.wizardModel);
      //console.log(this.wizardModel.FullName);
    },
    finishstep() {
      //swal('Good job!', 'You clicked the finish button!', 'success');
      //alert('God Bless You!');
      this.initialCheck = false;
      this.userType = this.userdata.user_type;
      if (this.userType == 'client'){
        this.checkSetupCompleteClient()
      } else {
        this.CheckRoleModule();
      }
    },
    CheckRoleModule() {              
      //console.log(user)
      var companyID = this.userdata.company_id;
      var roleid = this.userdata.role_id;
      this.userType = this.userdata.user_type;
      this.$sidebar.displaySidebar(true);
      
      if(this.userType == 'client') {
        this.$store.dispatch('checkUserSetupComplete', {
              usrID: this.userdata.id,
          }).then(response => {
              this.setClientFinishButtonText(response);
              this.$global.checkClientModule(response.setupcomplete,response.accessmodule);
              //console.log(response);
              if(response.accessmodule['leadspeek']) {
                if(!this.initialCheck) {
                  var lptype = response.accessmodule['leadspeek_type'];
                  lptype = lptype.split('|');
                  for(var i=0;i<lptype.length;i++) {
                    if (lptype[i] == 'local') {
                      document.location = '/' + this.userdata.leadlocalurl + '/dashboard';
                      return
                    }else{
                      document.location = '/' + this.userdata.leadlocatorurl + '/dashboard';
                    }
                  }
                  //this.$router.push({ name: this.userdata.leadlocalname });
                }else{
                  //console.log('here');
                  $('#finishheader').html('Thank you for completing your profile!');
                  //$('#finishsubheader').html('Click "Go to Dashboard" button to start using the application.');
                }
              }else{
                //console.log('there');
                //this.btnFinishShow = false;
              }
          },error => {
              
          });
      }else{
        this.$store.dispatch('GetRoleList', {
              companyID: companyID,
              getType:'getrolemodule',
              roleID:roleid,
              usrID: this.userdata.id,
          }).then(response => {
              //console.log(user);
              //this.rolemodulelist = response;
              //this.checkModuleRole(response);
              this.$global.checkModuleRole(response.modules,response.setupcomplete);
              if(!this.initialCheck) {
                //this.$router.push({ name: 'LeadSpeek' })
                this.$router.push({ name: 'General Setting' });
                // document.location = '/configuration/general-setting';
              }else{
                  $('#finishheader').html('Thank you for completing your profile!');
                  //$('#finishsubheader').html('Click "Go to Dashboard" button to start using the application.');
              }
          },error => {
              
          });
      }

    },
    checkSetupCompleteClient(){
      this.$store.dispatch('checkUserSetupComplete', {
          usrID: this.userdata.id,
      }).then(response => {
          this.setClientFinishButtonText(response);
          const localUrl = response.sidemenu && response.sidemenu.local && response.sidemenu.local.url ? `/${response.sidemenu.local.url}/dashboard` : null;
          const locatorUrl = response.sidemenu && response.sidemenu.locator && response.sidemenu.locator.url ? `/${response.sidemenu.locator.url}/dashboard` : null;
          const enhanceUrl = response.sidemenu && response.sidemenu.enhance && response.sidemenu.enhance.url ? `/${response.sidemenu.enhance.url}/dashboard` : null;
          const b2bUrl = response.sidemenu && response.sidemenu.b2b && response.sidemenu.b2b.url ? `/${response.sidemenu.b2b.url}/dashboard` : null;
          const simplifiUrl = response.sidemenu && response.sidemenu.simplifi && response.sidemenu.simplifi.url ? `/${response.sidemenu.simplifi.url}/campaign-management` : null;

          if(response.clientsidebar && response.clientsidebar.local && localUrl) {
            window.location.href = localUrl
          } else if (response.clientsidebar && response.clientsidebar.locator && locatorUrl) {
            window.location.href = locatorUrl
          } else if (response.clientsidebar && response.clientsidebar.enhance && enhanceUrl) {
            window.location.href = enhanceUrl
          } else if (response.clientsidebar && response.clientsidebar.b2b && b2bUrl) {
            window.location.href = b2bUrl
          } else if (response.clientsidebar && response.clientsidebar.simplifi && simplifiUrl) {
            window.location.href = simplifiUrl
          } else if(this.userdata.user_type == 'client'  && !localUrl  && !locatorUrl  && !enhanceUrl && !b2bUrl && !simplifiUrl) { 
            if (response.clientsidebar && response.clientsidebar.local && response.clientsidebar.local.url) {
              window.location.href = `/${response.clientsidebar.local.url}/dashboard`;
            } else if (response.clientsidebar && response.clientsidebar.locator && response.clientsidebar.locator.url) {
              window.location.href = `/${response.clientsidebar.locator.url}/dashboard`;
            } else if (response.clientsidebar && response.clientsidebar.enhance && response.clientsidebar.enhance.url) {
              window.location.href = `/${response.clientsidebar.enhance.url}/dashboard`;
            } else if (response.clientsidebar && response.clientsidebar.b2b && response.clientsidebar.b2b.url) {
              window.location.href = `/${response.clientsidebar.b2b.url}/dashboard`;
            } else if (response.clientsidebar && response.clientsidebar.simplifi && response.clientsidebar.simplifi.url) {
              window.location.href = `/${response.clientsidebar.simplifi.url}/campaign-management`;
            } else {
              window.location.href = '/'
            }
          } else {
            window.location.href = '/'
          }
      },error => {
        console.log(error);
        window.location.href = '/'
      });
    },
    onChangeManageCreditCard(value){
      this.manageCreditCard = value;
    },
    getStatusOnBoarding(){
      this.isSuccessFetchStatusOnBoarding = false;
      this.$store.dispatch('getStatusOnBoarding', {
        user_id: this.userdata.id,
      }).then(response => {
        this.statusOnBoarding = response.data;
        this.excludeOnBoarding = response.data_exclude_onboard_charge;
        this.registrationMethod = response.registration_method;
        this.isSuccessFetchStatusOnBoarding = true;
      }).catch(err => {
        this.isSuccessFetchStatusOnBoarding = true;
      })
    },
    onChangeBasicInformation(value){
      this.basicInformation = {...value};
      if (this.isErrorBasicInformation) {
        const stillError = this.checkInformationError(this.basicInformation);
        this.isErrorBasicInformation = stillError;
      }
    },
    onChangeBusinessInformation(value){
      this.businessInformation = {...value};
      if (this.isErrorBusinessInformation) {
        const stillError = this.checkInformationError(this.businessInformation);
        this.isErrorBusinessInformation = stillError;
      }
    },
    onPrevButton(){
      this.isRenderAgreementClient = false;
    },
    makeFinishSetup() {
      const userData = this.$store.getters.userData
      this.$store.dispatch('userSetupComplete', {
          usrID: userData.id,
          statuscomplete: 'T',
          answers: "",
          companyGroupID: "",
      }).then(response => {
        this.$store.dispatch('retrieveUserData',{
          usrID: userData.id,
        });

        this.$global.creditcardsetup = true;
      },error => {
          
      });
    },
    fetchUserData(){
      const userData = this.$store.getters.userData;

      this.$store.dispatch('retrieveUserData',{
        usrID: userData.id,
      }).then(response => {
        this.isLoadingFetchUser = false;
      }).catch(error => {
        this.isLoadingFetchUser = false;
      });
    },
    onCreditCardInfo(data){
      this.ccInfo = data;
    },
  },
  computed: {
    steps(){
      const steps = [];
      const userData = this.$store.getters.userData;
      
      const isClient = userData.user_type == 'client';
      const isAgency = userData.user_type == 'userdownline';
      const isCreditCard = userData.customer_payment_id;

      // for client 
      if(isClient){
        steps.push({
          key: 'info',
          label: 'Information',
          icon: 'fas fa-user-tie',
          type: 'info',
          beforeChange: () => this.validateStep('step2'),
        });
      }
      
      // console.log(isCreditCard);
      // console.log(this.statusOnBoarding);
      // console.log(this.isLoadingFetchUser);
      // console.log(this.$global.creditcardsetup);
      // console.log(this.$store.getters.userData);
      // console.log(this.$store.getters.userData.profile_setup_completed);
      if (!isCreditCard && !this.statusOnBoarding && (isClient || isAgency) && !this.isLoadingFetchUser) {
        steps.push({
          key: 'payment1',
          label: 'Payment Setup',
          icon: 'tim-icons icon-bank',
          type: 'component',
          component: 'third-step',
          ref: 'step1',
          beforeChange: () => this.validateStep('step1'),
          props: {
            isMinimumSpend: this.minspend_setting.status,
            isRenderAgreementClient: this.isRenderAgreementClient,
            excludeOnBoarding: this.excludeOnBoarding,
          },
        });
      }
//console.log(this.registrationMethod);
//console.log(this.$global.menuLeadsPeek);
      const registerFromSaveAndCharge = this.registrationMethod === 'save_and_charge';

      if (this.statusOnBoarding && isAgency && registerFromSaveAndCharge && !this.$global.creditcardsetup) {
        steps.push({
          key: 'payment2',
          label: 'Payment Setup',
          icon: 'tim-icons icon-bank',
          type: 'onboarding',
          beforeChange: () =>
            this.validateStep(this.manageCreditCard === 'existing' ? 'stepExistingCard' : 'stepUpdateCard'),
        });
      }

      // for agency
      if(!isClient){
        steps.push({
          key: 'info',
          label: 'Information',
          icon: 'fas fa-user-tie',
          type: 'info',
          beforeChange: () => this.validateStep('step2'),
        });
      }

      steps.push({
        key: 'finish',
        label: 'Finish Setup',
        icon: 'fas fa-medal',
        type: 'component',
        component: 'finish-step',
        ref: 'step5',
        beforeChange: () => this.validateStep('step5'),
        props: {
          finishButtonText: this.btnFinishTxt,
        },
      });

      return steps;
    },
    MINIMUM_SPEND_FLAT(){
      return MINIMUM_SPEND.FLAT
    }
  },
  mounted() {
    this.fetchUserData();
    this.minspend_setting = this.$global.rootminspendsetting ? this.$global.rootminspendsetting : this.minspend_setting;
    this.userdata = this.$store.getters.userData
    this.CheckRoleModule();
    //this.isAdmin = false;
    //console.log(this.userdata);
    this.isAdmin = false;
    this.questionnaireCompleted = true;
    if ((this.userdata.isAdmin == 'T' && this.userType == 'user') || this.userdata.customer_payment_id != '') {
      this.isAdmin = true;
    }

    if(this.userdata.questionnaire_setup_completed == 'T' || this.userdata.isAdmin == 'T' || this.userdata.user_type == 'user' || this.userdata.user_type == 'userdownline' || this.userdata.disable_client_add_campaign == 'T') {
      this.questionnaireCompleted = true;
    }

    if (this.userdata.user_type === 'client') {
      this.btnFinishTxt = 'Finish';
    } else {
      this.btnFinishTxt = 'Go To General Settings';
    }

    if(this.userdata.user_type == 'userdownline' && this.$global.agencyplatformroot == true) {
      this.emmplatform = true;
    }

    this.getStatusOnBoarding();
  }
};

</script>
<style type="text/css">
 .card-wizard .nav-pills .nav-item .nav-link p {
   width: 120px;
 }

.error-class {
  border: 1px solid red;
  background-color: #ffe6e6;
}

.error-class .el-collapse-item__header {
  color: red;
}
</style>
